import { render } from "./LawyersListShowModal.vue?vue&type=template&id=6fbae0c0"
import script from "./LawyersListShowModal.vue?vue&type=script&lang=js"
export * from "./LawyersListShowModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__